<template>
  <div>
    <div>
      <mq-layout :mq="['mobile', 'tablet']" class="bodyDesktop">
        <div v-if="tastedWines.length > 0" class="titleParent">
          <div class="titleClassF">{{ $t('home.moreWines') }}</div>
        </div>
        <div class="desktop-tasting-item-wrapper" v-for="tasting in tastedWines" :key="tasting.id">
          <tasting-list-item :id="tasting.id" />
        </div>

        <div class="titleParent">
          <div class="titleClassG">{{ $t('home.wineSelection') }}</div>
        </div>
        <div
          class="desktop-tasting-item-wrapper"
          v-for="tasting in nonTastedWines"
          :key="tasting.id"
        >
          <tasting-list-item :id="tasting.id" />
        </div>
      </mq-layout>

      <mq-layout :mq="['desktop']">
        <div class="header-shadow" :style="{ backgroundImage: 'url(' + bgImg + ')' }" />

        <div class="container">
          <div class="block">
            <div v-if="tastedWines.length > 0" class="titleParent">
              <div class="titleClassF">{{ $t('home.moreWines') }}</div>
            </div>

            <div class="bodyDesktop">
              <div
                class="desktop-tasting-item-wrapper"
                v-for="tasting in tastedWines"
                :key="tasting.id"
              >
                <tasting-list-item :id="tasting.id" />
              </div>
            </div>
          </div>
          <div class="titleParent">
            <div class="titleClassG">{{ $t('home.wineSelection') }}</div>
          </div>
          <div class="bodyDesktop">
            <div
              class="desktop-tasting-item-wrapper"
              v-for="tasting in nonTastedWines"
              :key="tasting.id"
            >
              <tasting-list-item :id="tasting.id" />
            </div>
          </div>
        </div>
      </mq-layout>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TastingListItem from '@/components/tasting/TastingListItem'

export default {
  name: 'TastingList',
  components: { TastingListItem },
  data() {
    return {
      tastedWines: [],
      nonTastedWines: [],
      bgImg: require('@/assets/background-tasting.png')
    }
  },

  computed: mapState(['completion', 'tasting']),

  mounted() {
    const tastings = this.tasting.tastings || []
    const tastingLength = tastings.length
    for (let i = 0; i < tastingLength; i++) {
      const currentBottle = tastings[i]
      const tastedBottle = Object.keys(this.completion.tasting).find(bottle => {
        if (bottle === currentBottle.id) {
          return bottle
        }
      })

      if (tastedBottle) {
        this.tastedWines.push({
          ...currentBottle,
          rating: tastedBottle.rating
        })
      } else {
        this.nonTastedWines.push(currentBottle)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-shadow {
  display: flex;
  margin-top: 75px;
  width: 100%;
  height: 650px;
  background-attachment: fixed;
}
.container {
  display: flex;
  flex-direction: column;
  border-radius: 60px 60px 0px 0px;
  background-color: #fff;
  width: 100%;
  height: 100%;
  float: left;
  margin-top: -60px;
}
.block {
  display: flex;
  flex-direction: column;
  padding: 25px 5px 0 25px;
  padding-top: 75px;
}

.titleClassF {
  margin-left: (-30px);
  display: flex;
  justify-content: flex-end;
  // font: normal normal 800 21px/29px Friends;
  text-transform: uppercase;
  // font: normal normal medium 50px/25px DM Sans;
  font: normal normal bold 25px Helvetica;
  color: #404040;
  letter-spacing: 0px;
  // color: $primary;
  border: black solid 2px;
  cursor: pointer;
  width: 60%;
  padding: 5px;
}

.titleClassG {
  margin-left: 40%;
  display: flex;
  justify-content: flex-start;
  text-transform: uppercase;
  font: normal normal bold 25px Helvetica;
  color: #404040;
  letter-spacing: 0px;
  border: black solid 2px;
  width: 60%;
  padding: 5px;
  cursor: pointer;
  margin-right: (0px);
  border-right-style: none;
}

.leftButton {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.backButton {
  margin-right: 35px;
  cursor: pointer;
  background-color: #ffffff;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  box-shadow: 3px 3px 3px #bebebe, -4px -4px 4px #ffffff;
  img {
    height: 60%;
    width: 60%;
    margin-right: 4px;
    transform: rotate(180deg);
  }
  &:hover {
    box-shadow: -3px -3px 4px #bebebe, 3px 3px 2px #ffffff;
  }
}
.bodyDesktop {
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: 60px;
  padding-left: 50px;
  padding-right: 50px;
}
.link-wrapper {
  width: 85%;
  margin-bottom: 15px;
  display: inline-block;
  box-sizing: border-box;
  padding: 20px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #b0b4cb;
  border-radius: 10px;
  @media screen and (min-width: 620px) {
    width: 46%;
    margin-left: 20px;
    padding: 10px 25px 20px 10px;
  }
}

.desktop-tasting-item-wrapper {
  border-radius: 10px;
  width: 33%;
  @media screen and (max-width: 1700px) {
    width: 45%;
  }
  @media screen and (max-width: 1300px) {
    width: 95%;
  }
  margin: 10px 0px 15px 10px;
  // padding-right: 200px;
  display: inline-block;
  box-sizing: border-box;

  background: #e3e3e3 0% 0% no-repeat padding-box;
  border-radius: 48px;
  margin: 20px 20px;
  padding: 15px;
}

.NoTastings {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .MainContainer {
    width: 60%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    // padding-left: 200px;
    position: relative;
    bottom: 50px;

    .Title {
      font-size: 2rem;
      font-family: Helvetica, sans-serif;
      margin-bottom: 57px;
      text-align: center;
    }

    .Subtitle {
      font-size: 1rem;
      font-family: Helvetica, sans-serif;
      margin-bottom: 30px;
      text-align: center;
    }

    .Cta {
      display: flex;
      margin-left: auto;
      margin-right: auto;
      justify-content: space-evenly;
      align-items: center;

      > * {
        font-size: 0.8rem;
        margin-left: 30px;
        margin-right: 30px;
      }
    }
  }

  .Illustration {
    width: 30%;

    img {
      width: 100%;
      height: auto;
    }
  }

  &--small {
    flex-direction: column;

    .MainContainer {
      bottom: -50px;
      width: 80%;

      .Title {
        font-size: 1.75rem;
      }

      .Cta {
        flex-direction: column;

        & > * {
          margin-left: 0;
          margin-right: 0;
          margin-bottom: 30px;
        }
      }
    }

    .Illustration {
      margin-top: 20px;
      width: 70%;
      overflow-y: hidden;
    }
  }
}

.titleParent {
  display: flex;
  margin-left: 0%;
  width: 100%;
}

@media screen and (max-width: 385px) {
  .titleClassF {
    width: 100%;
    padding: 5px;
    margin-left: -55px;
  }

  .titleClassG {
    width: 100%;
    padding: 5px;
    margin-right: -55px;
  }
}

@media (max-width: 1024px) {
  .titleClassF {
    width: 90%;
    padding: 5px;
    margin-left: -55px;
  }

  .titleClassG {
    width: 90%;
    padding: 5px;
    margin-right: -51px;
  }
}
</style>
